import { render, staticRenderFns } from "./GridList.vue?vue&type=template&id=c0922c46&scoped=true"
import script from "./GridList.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridList.vue?vue&type=style&index=0&id=c0922c46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0922c46",
  null
  
)

export default component.exports